import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef, useEffect } from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { Tooltip } from '../Tooltip/Tooltip.esm.js';
import { TruncateText } from '../TruncateText/TruncateText.esm.js';

function Tab(_a) {
    var disabledReason = _a.disabledReason, props = __rest(_a, ["disabledReason"]);
    var buttonRef = useRef(null);
    useEffect(function () {
        var _a;
        if (props.hasFocus)
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [props.hasFocus, buttonRef]);
    var buttonProps = __assign(__assign({}, props), { tabIndex: props.hasFocus ? 0 : -1 });
    if (props.disabled && disabledReason) {
        return (React.createElement(Tooltip, { label: disabledReason },
            React.createElement("div", null,
                React.createElement(Button, __assign({}, buttonProps, { ref: buttonRef })))));
    }
    return React.createElement(Button, __assign({}, buttonProps, { ref: buttonRef }));
}
var Button = forwardRef(function (_a, ref) {
    var id = _a.id, _b = _a.active, active = _b === void 0 ? false : _b, children = _a.children, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, onKeyDown = _a.onKeyDown, tabIndex = _a.tabIndex;
    var className = classNames("tw-box-border tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-bg-transparent tw-flex tw-items-center tw-px-4 tw-h-8 ", "focus:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-inset tw-box-content tw-text-default dark:tw-text-dark-bg", disabled
        ? "tw-cursor-not-allowed tw-text-disabled dark:tw-text-dark-bg-disabled tw-text-sm"
        : "hover:tw-bg-blue-100 dark:hover:tw-bg-gray-900", active
        ? "tw-border-b tw-border-blue-600 dark:tw-border-blue-600"
        : "tw-border-b dark:hover:tw-border-gray-900 tw-border-transparent");
    var labelText = React.createElement(TruncateText, { appearance: "dark" }, children);
    return (React.createElement("button", { "data-metrics": dataMetrics, "data-testid": dataTestId || id, id: id, className: className, role: "tab", "aria-selected": active, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, ref: ref, tabIndex: tabIndex, type: "button", style: { maxWidth: "16rem" } }, labelText));
});
Button.displayName = "Button";

export { Tab };
//# sourceMappingURL=Tab.esm.js.map
